import { useMsal } from "@azure/msal-react";
import { useAuth } from "./useAuth.jsx";
import { isE2EAuthBypassEnabled } from "../../e2eAuthBypass.js";

// Only initial bootstrap may substitute a sign-in loading screen. Subsequent
// MSAL interaction must leave the established provider and editor mounted.
export default function SessionWorkspaceBoundary({ children, loading }) {
  const { isAuthenticated, hasWorkspace } = useAuth();
  const { inProgress } = useMsal();
  if (!isAuthenticated && !hasWorkspace && !isE2EAuthBypassEnabled() && inProgress !== "none") return loading;
  return children;
}
